enum quickLinksItemTestIds {
	quickLinksContainer = 'quick-links-container',
}

export default quickLinksItemTestIds;
